// src/pages/ContractMaintenanceFormPage.tsx

import React, {useCallback, useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {MaintenanceService} from "../../../service/MaintenanceService";
import AAlert from "../../../components/molecules/AAlert";
import PropertyForm from "../../../components/molecules/PropertyFormProps";
import {BusinessProperty, normalizePropertyData} from "../../../model/BusinessProperty";

const BASE_URL:string | undefined = process.env.REACT_APP_BACKOFFICE_API_URL;

const ContractMaintenanceFormPage: React.FC = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [properties, setProperties] = useState<BusinessProperty[]>([]);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [newValue, setNewValue] = useState('');
    const [alert, setAlert] = useState<{ message: string; type: string; visible: boolean }>({
        message: '',
        type: '',
        visible: false,
    });


    const fetchProperties = async () => {
        try {
            const url = `${BASE_URL}/maintenance/variables`;
            if(!BASE_URL)
                throw new Error('URL não definida');

            const data = await MaintenanceService.fetchProperties(url , normalizePropertyData);
            setProperties(data);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching properties:', error);
            navigate('/error');
        }
    }

    useEffect(() => {
        fetchProperties();
    }, [] );


    const handlePropertyChange = (value: string) => {
        console.log("handlePropertyChange", value);
        setSelectedProperty(value);
        setNewValue('');
    };

    const handleValueChange = (value: string) => {
        console.log("handleValueChange", value);
        setNewValue(value);
    };

    const showAlert = (message: string, type: 'success' | 'error' | 'warning' | 'info') => {
        console.log("show alert");
        setAlert({ message, type, visible: true });
    };

    const closeAlert = () => {
        console.log("close alert");
        setAlert({ ...alert, visible: false });
    };

    const saveProperty = async () => {
        try {
            console.log(`Trocando as propriedades ${selectedProperty}-${newValue}`);
            await MaintenanceService.updateProperty(`${BASE_URL}/maintenance/variables`, selectedProperty,newValue);
            showAlert('Ação realizada com sucesso!', 'success');
            fetchProperties();
        } catch (error) {
            console.error('Error:', error);
            showAlert('Erro ao salvar a propriedade', 'error');
        }
    }

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className='px-4'>
            {alert.visible && (
                <AAlert message={alert.message} type={alert.type as any} onClose={closeAlert} />
            )}
            <h1 className="text-2xl text-teal-500 font-medium tracking-tight pt-2 pb-3">
                Manutenção de Variaveis da Click Sing
            </h1>
            <PropertyForm
                properties={properties}
                selectedProperty={selectedProperty}
                onPropertyChange={handlePropertyChange}
                onValueChange={handleValueChange}
                newValue={newValue}
                title="Varivaeis de Propriedade da clickSing"
            />
            <button
                className='p-2 text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center mr-2 mb-2'
                onClick={saveProperty}
                disabled={!selectedProperty || !newValue}
            >
                Salvar
            </button>
        </div>
    );
};

export default ContractMaintenanceFormPage;